<template>
  <div>
    <div v-show="online">
      <keep-alive>
        <router-view />
      </keep-alive>
      <!-- 添加动态样式 -->
      <audio ref="ad" autoplay @play="handlePlay" @pause="handlePause"></audio>
    </div>
    <div v-show="!online" class="outLine">
      <div class="container">
        <img src="@/assets/outLine.png" alt />
        <div class="outTitle">网络中断</div>
        <div class="outDesc">当前网络已断开，刷新试试</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth.js'
export default {
  data() {
    return {
      audioState: {
        isPlaying: false
      },
      online: false
    }
  },
  created() {
    var token = getToken()
    if (!token) {
      this.$router.push('./login')
    }
    // main.js 或 App.vue
    // window.addEventListener('pagehide', (event) => {
    //   const audioPlayer = this.$refs.ad
    //   if (audioPlayer) {
    //     const currentTime = audioPlayer.currentTime
    //     localStorage.setItem('currentTime', currentTime)
    //   }
    // })
    // document.addEventListener('visibilitychange', () => {
    //   if (document.visibilityState === 'hidden') {
    //     // 页面不可见时暂停音频
    //     const audioPlayer = this.$refs.ad
    //     if (audioPlayer && !audioPlayer.paused) {
    //       audioPlayer.pause()
    //     }
    //   }
    // })
  },
  // 给所有的子组件提供播放功能DOM
  provide() {
    return {
      ad: this.$refs,
      audioState: this.audioState
    }
  },
  methods: {
    handlePlay() {
      this.audioState.isPlaying = true
    },
    handlePause() {
      this.audioState.isPlaying = false
    },
    // 检查网络状态的函数
    updateOnlineStatus() {
      if (navigator.onLine) {
        this.online = true //网络在线
      } else {
        this.online = false //网络掉线
      }
    }
  },
  mounted() {
    const audio = this.$refs.ad
    var that = this
    if (audio) {
      audio.addEventListener('play', this.handlePlay)
      audio.addEventListener('pause', this.handlePause)
    }
    document.addEventListener('DOMContentLoaded', function () {
      // 监听网络连接状态变化的事件
      window.addEventListener('online', that.updateOnlineStatus)
      window.addEventListener('offline', that.updateOnlineStatus)
      // 初始检查网络状态
      that.updateOnlineStatus()
    })
  },
  beforeDestroy() {
    const audio = this.$refs.ad
    if (audio) {
      audio.removeEventListener('play', this.handlePlay)
      audio.removeEventListener('pause', this.handlePause)
    }
  }
}
</script>

<style scoped lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html {
  scroll-behavior: smooth;
  overflow-y: scroll;
}

* {
  margin: 0;
  padding: 0;
}

a {
  list-style: none;
  color: unset;
  text-decoration: none;
}

ul,
li {
  list-style: none;
}
.outLine {
  width: 100%;
  height: 100vh;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  position: relative;
  .container {
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translateX(-50%);
    font-family: PingFangSC, PingFang SC;
    height: 225px;
    text-align: center;
    img {
      width: 160px;
      height: 153px;
    }
    .outTitle {
      font-weight: 500;
      font-size: 16px;
      color: #3b3f4c;
      margin-top: 15px;
    }
    .outDesc {
      font-size: 14px;
      color: #969799;
      margin-top: 10px;
    }
  }
}
</style>
